export { default as TableLegend } from './component';
